"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var BackIcon = function BackIcon() {
  return _react2.default.createElement(
    "svg",
    { width: "9px", height: "17px", viewBox: "0 -1 9 17", version: "1.1" },
    _react2.default.createElement("path", { d: "M1.14133559,7.61676538 C1.15403474,7.64383911 1.17148783,7.66918418 1.19377977,7.69147612 L7.42602039,13.9237167 C7.5332039,14.0309003 7.7019381,14.0294132 7.80692739,13.9244239 C7.90884619,13.8225051 7.91160007,13.6488967 7.80622023,13.5435169 L1.76239881,7.49969547 L7.80622023,1.45587404 C7.91340375,1.34869053 7.91191667,1.17995633 7.80692739,1.07496704 C7.70500858,0.973048234 7.53140022,0.970294355 7.42602039,1.07567419 L1.19377977,7.30791481 C1.10871949,7.39297508 1.09209915,7.51679952 1.14133559,7.61676538 Z", id: "Combined-Shape", stroke: "#FFFFFF", strokeWidth: "1", fill: "#FFFFFF", fillRule: "evenodd" })
  );
};

exports.default = BackIcon;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/SpotSearch/icons/BackIcon.js
// module id = 658
// module chunks = 11